import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Pipe for translating DB camera types to user-facing equivalent.
 */
@Pipe({
  name: 'cameraTypeName',
  standalone: false,
})
export class CameraTypeNamePipe implements PipeTransform {

  public constructor(
    @Inject(TranslateService) private readonly translate: TranslateService,
  ) {}

  /**
   * Transforms camera type to translated type name
   * @param type Type name from database
   * @returns Translated name or original if no translation found
   */
  public transform(type: string | null): string {
    const key = `health.inventory.cameras.type.${type}`;
    const translated = this.translate.instant(key);
    if (translated === key) {
      // No translation hit, return original type.
      return type ?? '';
    }

    return translated;
  }

}
